import React, { useState, useEffect, forwardRef } from 'react';
import { useSwipeable } from 'react-swipeable';
import { Stations } from './stations';
import { wrap } from 'popmotion';
import { AppContext } from '../../App';
import { List } from './list';

import styles from './guide-animation.module.scss';
import { getTrans } from '../../Utils/translate';

const GuideAnimation = forwardRef(
  (
    { config, animationDuration, animationPath, suffix, eventType, showMini = false },
    ref
  ) => {
    let animationTimeout = undefined;

    const [items, setItems] = useState([]);
    const [current, setCurrent] = useState(0);
    const [preloaded, setPreloaded] = useState(false);
    const context = React.useContext(AppContext);
    const { diveDifficulty } = context.lang;

    useEffect(() => {
      setCurrent(0);
      setPreloaded(false);
    }, [items]);

    useEffect(() => {
      setItems(
        config.dive_type.stations
          .sort((a, b) =>
            a.hasOwnProperty('order') && b.hasOwnProperty('order')
              ? a.order > b.order
                ? 1
                : -1
              : !a.hasOwnProperty('order')
              ? 0
              : !b.hasOwnProperty('order')
              ? -1
              : 0
          )
          .filter(
            (station) =>
              !station.hasOwnProperty('value') ||
              (station.hasOwnProperty('value') &&
                station.value &&
                station.value !== 'false')
          )
      );
    }, [config.dive_type.stations]);

    useEffect(() => {
      const changeCurrent = () => {
        clearTimeout(animationTimeout);
        setCurrent(wrap(0, items.length, current + 1));
        animationTimeout = setTimeout(() => {
          changeCurrent();
        }, animationDuration);
      };

      if (!preloaded && items.length) {
        for (let i = 0; i < items.length; i++) {
          const item = items[i];
          const image = new Image();

          image.src = `${animationPath}${item.type}${
            item.position ? `_${item.position}` : ''
          }${suffix ? `_${suffix}` : ''}.gif`;
        }

        setPreloaded(true);
      }

      // eslint-disable-next-line
      animationTimeout = setTimeout(() => {
        changeCurrent();
      }, animationDuration);

      return () => {
        clearTimeout(animationTimeout);
      };
    }, [items, current, preloaded]);

    const swipeHandlers = useSwipeable({
      onSwipedLeft: () => setCurrent(wrap(0, items.length, current + 1)),
      onSwipedRight: () => setCurrent(wrap(0, items.length, current - 1)),
    });

    const getAnimationImageSrc = () => `${animationPath}${items[current].type}${
      items[current].position ? `_${items[current].position}` : ''
    }${suffix ? `_${suffix}` : ''}.gif`;

    return (
      <div ref={ref}>
        {eventType === 'cliff' && (
          <>
            <Stations
              items={items.map((station) =>
                station.hasOwnProperty('value')
                  ? typeof station.value !== 'boolean' &&
                    station.value !== 'true' &&
                    station.value !== 'false'
                    ? `${station.type} X${station.value}`
                    : station.type
                  : station.position
              )}
              current={current}
              eventType={eventType}
            />
            <div className={styles.difficulty}>
              {getTrans(diveDifficulty)}: {config.dive_difficulty}
            </div>
          </>
        )}

        {items[current] && (
          <img
            src={getAnimationImageSrc()}
            className={styles.animationImage}
            alt="Dive animation"
            {...swipeHandlers}
          />
        )}
        {!showMini &&
          config.lists &&
          config.lists.map((list) => <List data={list} key={list} />)}
      </div>
    );
  }
);

export default GuideAnimation;
